import LabV2PopupModal from 'components/App/ModalPopups/LabV2PopupModal'
import { ModalElementContext } from 'contexts/ModalProvider'
import useLabUiPreview from 'hooks/useLabUiPreview'
import noop from 'lib/function/noop'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

export default function LabUiPreviewOverlay() {
  const { items } = useLabUiPreview()
  const item = items.find(item => item.type === 'popup')
  const snackbar = items.find(item => item.type === 'snackbar')
  const [dismissedId, setDismissedId] = useState<string>()
  const snackbarId = useRef<string | undefined>(undefined)
  const dismiss = useCallback(() => setDismissedId(item?.id), [item?.id])
  const modalContext = useMemo(() => ({
    open: !!item && dismissedId !== item.id,
    resolve: dismiss,
    afterClose: noop,
  }), [item, dismissedId, dismiss])

  useEffect(() => {
    if (snackbar && snackbarId.current !== snackbar.id) {
      snackbarId.current = snackbar.id
      showSnackbar(snackbar.payload.description, snackbar.payload.kind, { heading: snackbar.payload.heading })
    }
  }, [snackbar])

  return item?.type === 'popup' ? <ModalElementContext value={modalContext}>
    <LabV2PopupModal popup={item.payload} />
  </ModalElementContext> : null
}
